import { Size } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { NavigationProperties } from '../../types/common';

import NavTab from './NavTab/NavTab';
import styles from './Navigation.scss';

const Navigation = <T extends string>({
  navTabs = [],
  selectedTab,
  onSelectTab,
  infoRef,
  className
}: NavigationProperties<T>) => {
  const { greaterThan } = useScreenSize();
  const smallScreen = !greaterThan(Size.XXSmall);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);

  return (
    <nav className={isDesktopEmbedded ? styles.embeddedContainer : styles.navContainer}>
      <ul className={styles.nav}>
        {navTabs.map((navTab, index) => {
          const { tabActiveStyle = '' } = navTab;
          const isActive = navTab.tabName === selectedTab;
          const navTabProps = {
            className: classNames(styles.button, {
              [styles.active]: isActive,
              [tabActiveStyle]: isActive
            }),
            onClick: () => onSelectTab(navTab.tabName),
            translation: smallScreen ? navTab.shortTitle : navTab.title,
            alias: navTab.alias,
            routeValues: navTab.routeValues
          };

          return (
            <NavTab
              key={navTab.tabName}
              navTab={navTab}
              isActive={isActive}
              navClassName={className}
              infoRef={infoRef}
              {...navTabProps}
            />
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
